
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["wasm"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "9773a65b.worker.js", { name: "[contenthash:8].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "9773a65b.worker.js");
					addMethods(w, methods)
					
					return w
				}
			